module.exports = __webpack_public_path__ + "static/media/checkbox_selected.8d90520b.svg";